import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import {
  ParametrosSolitudServiciosEntity,
  ServicioSolitudServiciosService,
  ReporteFormulasMedicasFiltro
} from 'src/app/services/servicio-solicitud-servicios.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-header-formulas-medicas',
  templateUrl: './header-formulas-medicas.component.html',
  styleUrls: ['./header-formulas-medicas.component.css']
})
export class HeaderFormulasMedicasComponent implements OnInit {

  @Input() parametros: ParametrosSolitudServiciosEntity;
  @Input() evolucion: boolean;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  suministros: SelectItem[] = [];
  profesionales: SelectItem[] = [];
  fechaOrden: string = moment().format('YYYY-MM-DD');
  discriminarNoPos: boolean = false;

  suministrosSelected = [];
  profesionalesSelected = [];

  constructor(private formulasMedicasService: ServicioSolitudServiciosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }

  ngOnInit() {
    this.getSuministros();
  }

  async getSuministros() {
    let response;
    if (this.evolucion) {
      response = await this.formulasMedicasService.getSuministrosEvolucion(this.parametros);
    } else {
      response = await this.formulasMedicasService.getSuministros(this.parametros);
    }
    response.subscribe((data: object) => {
      const listSuministros = data['#result-set-1'];
      if (listSuministros) {
        listSuministros.forEach(suministroRes => {
          this.suministros.push({
            label: suministroRes['dscrpcn_mdcmnto'],
            value: suministroRes['unco']
          });
          this.suministrosSelected.push(suministroRes['unco']);
        });
        if (this.evolucion) {
          this.generar();
        } else {
          this.getProfesionales();
        }
      }
    }, (error) => {
      console.log('Error HeaderFormulasMedicas.getSuministros()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de suministros, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    })
  }

  async getProfesionales() {
    const response = await this.formulasMedicasService.getProfesionalesFormulaMedica(this.parametros);
    response.subscribe((data: object) => {
      const listProfesionales = data['data'];
      if (listProfesionales) {
        listProfesionales.forEach(profesionaRes => {
          this.profesionales.push({
            label: profesionaRes['profesional'],
            value: profesionaRes['unco']
          });
          this.profesionalesSelected.push(profesionaRes['unco']);
        });
        this.generar();
      }
    }, (error) => {
      console.log('Error HeaderFormulasMedicas.getProfesionales()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    })
  }

  generar() {
    const suminsitros = this.suministrosSelected.toString();
    const profesionales = this.profesionalesSelected.toString();
    if (suminsitros.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Suministro</strong>.');
    } else if (!this.evolucion && profesionales.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>profesional</strong>.');
    } else if (this.fechaOrden.length === 0) {
      this.errorGenerado.emit('Debe elegir una <strong>fecha de orden</strong>.');
    } else {
      const filtro: ReporteFormulasMedicasFiltro = {
        suminsitros,
        profesionales,
        discriminarNoPos: this.discriminarNoPos,
        fechaOrden: this.fechaOrden
      }
      this.filtrosSeleccionados.emit(filtro);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    let id = this.evolucion ? 'reporte-formulas-evolucion' : 'reporte-formulas-hc';
    printContents = document.getElementById(id).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
